import { POST_TYPES } from "@/nostr/api/feed"
import { useTranslation } from "@/i18n"
import type { PostTypeSelection } from "@/nostr/api/filters/filterEngine"

const LABELS: Record<PostTypeSelection, string> = {
  all: "All types",
  note: "Notes",
  reply: "Replies",
  repost: "Reposts",
  article: "Articles",
}

const OPTIONS: PostTypeSelection[] = ["all", ...POST_TYPES]

export interface PostTypeFilterProps {
  value: PostTypeSelection
  onChange: (value: PostTypeSelection) => void
  className?: string
}

/**
 * Post type filter shared by every post list.
 *
 * A single selection keeps the meaning obvious ("Replies" never means "notes
 * and replies") and lets feeds request exactly the relay kinds they need.
 */
export function PostTypeFilter({ value, onChange, className = "" }: PostTypeFilterProps) {
  const { t } = useTranslation()

  return (
    <div
      className={`post-type-filter ${className}`.trim()}
      role="group"
      aria-label={t("Filter posts by type")}
    >
      {OPTIONS.map((option) => {
        const active = option === value
        return (
          <button
            key={option}
            type="button"
            className={`chip filter-chip ${active ? "active" : ""}`.trim()}
            aria-pressed={active}
            onClick={() => onChange(option)}
          >
            {t(LABELS[option])}
          </button>
        )
      })}
    </div>
  )
}
